import CityPageTemplate from "../city-template/CityPageTemplate";
import { glenAllenVaConfig } from "./data";

export default function GlenAllenVaPage() {
  return <CityPageTemplate config={glenAllenVaConfig} />;
}